import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Color } from '../../../core/types/color';

@Component({
    selector: 'app-card-title',
    templateUrl: './card-title.component.html',
    styleUrls: ['./card-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CardTitleComponent {

  @Input() public faIcon?: IconProp;
  @Input() public iconBgColor?: Color;
  @Input() public size: 'regular' | 'large' = 'regular';
  @Input() public center?: boolean;

  @HostBinding('class')
  protected get classes(): string {
    return [
      'classes',
      this.size,
      this.center ? 'center' : undefined
    ]
      .filter(c => !!c)
      .join(' ');
  }

}
